module.exports = __webpack_public_path__ + "img/util-more.b169a0a2.svg";